/* eslint-disable no-useless-constructor */
import feathersClient, { BaseModel, makeServicePlugin } from "../../feathers-client";

class MISONode extends BaseModel {
  constructor(data, options) {
    super(data, options);
  }

  static modelName = "MISONode";
}

const servicePlugin = makeServicePlugin({
  Model: MISONode,
  service: feathersClient.service("data-services/miso/nodes"),
  idField: "Node",
  nameStyle: "path",
  getters: {},
});

export default servicePlugin;
